// extracted by mini-css-extract-plugin
export default {"body":"QueryHistoryWidget_body__i+xCP","notFound":"QueryHistoryWidget_notFound__UOrYP","pagination":"QueryHistoryWidget_pagination__BP1xZ"};